<template>
  <div class="callout" :class="typeClass">
    <div class="icon">
      <icon name="questionRound"/>
    </div>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Callout',

  props: {
    type: {
      type: String,
      default: 'message',
    },
  },

  computed: {
    typeClass() {
      return this.type;
    },
  },
};
</script>

<style scoped lang="scss">
.callout {
  text-align: left;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  background: $colour-nhs-core-white;
  color: $colour-nhs-black;
  display: flex;
  align-items: center;

  p {
    margin: 0;
    padding: 0;
    line-height: 1.2;
    font-size: 14px;
  }

  a {
    font-weight: bold;
    text-decoration: none;
    color: $colour-nhs-black;
  }

  .icon {
    max-width: 25px;
    margin-right: 10px;
  }
  
  &.warning {
    border: 1px solid #e26d00;

    svg {
      width: 25px;
      height: 25px;
      float: left;
      margin-right: 10px;
    }
  }

  &.error {
    border: 1px solid $colour-nhs-emergency-red;
  }
}
</style>

<style lang="scss">
.warning {
  svg {
    path {
      fill: #e26d00;
    }
  }
}
.warning-solid {
  svg {
    path {
      fill: #ffffff;
    }
  }
}

.error {
  svg {
    path {
      fill: $colour-nhs-emergency-red;
    }
  }
}
</style>
